import { render, staticRenderFns } from "./RmaRequestForm.vue?vue&type=template&id=4275d59e&scoped=true"
import script from "./RmaRequestForm.vue?vue&type=script&lang=js"
export * from "./RmaRequestForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4275d59e",
  null
  
)

export default component.exports